import image from './oneRecord.png';
function SQLHabitLogo() {
  return (
    <img src={String(image)} alt="One Record" width="101" height="50" /> 

  );
}

export default SQLHabitLogo;
